"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeDescriptions = void 0;
var TypeDescriptions = {};
exports.TypeDescriptions = TypeDescriptions;
TypeDescriptions.String = {
    name: "String"
};
TypeDescriptions.Number = {
    name: "Number"
};
TypeDescriptions.Expression = {
    name: "Expression"
};
TypeDescriptions.Html = {
    name: "Html"
};
TypeDescriptions.Json = {
    name: "Json"
};
TypeDescriptions.PageSelect = {
    name: "PageSelect"
};
TypeDescriptions.CssClass = {
    name: "CssClass"
};
TypeDescriptions.Boolean = {
    name: "Boolean"
};
TypeDescriptions.KeyValuePairs = {
    name: "array",
    properties: {
        "id": TypeDescriptions.String,
        "value": TypeDescriptions.String,
    }
};
//# sourceMappingURL=TypeDescriptions.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/journey-model/dist/journey/annotations/TypeDescriptions.js
// module id = 2096
// module chunks = 0